document.addEventListener('click', (event) => {
	if (event.target.matches('.location-infobanner-closetext') || event.target.matches('.location-infobanner-x')) {
		event.preventDefault();
		const infobanners = document.getElementsByClassName('location-infobanner');
		const infobanner = infobanners[0];
		infobanner.classList.remove('enabled');
	}
}, false);
